module.exports = __webpack_public_path__ + "static/media/Tax.f8b6f3df.png";